import { render, staticRenderFns } from "./MultiStepForm.vue?vue&type=template&id=0c131f70&"
import script from "./MultiStepForm.vue?vue&type=script&lang=ts&"
export * from "./MultiStepForm.vue?vue&type=script&lang=ts&"
import style0 from "./MultiStepForm.vue?vue&type=style&index=0&id=0c131f70&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports